import { render, staticRenderFns } from "./Machine8.vue?vue&type=template&id=7b4ca347&scoped=true&"
import script from "./Machine8.vue?vue&type=script&lang=js&"
export * from "./Machine8.vue?vue&type=script&lang=js&"
import style0 from "./Machine8.vue?vue&type=style&index=0&id=7b4ca347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4ca347",
  null
  
)

export default component.exports